
import styles from './ChannelFilter.module.scss';
import { useEffect, useState } from 'react';
import { LuChevronDown as DownIcon } from "react-icons/lu";
import { Popover } from 'react-tiny-popover';
import MeritoButton from '../../../../components/common/MeritoButtons/MeritoButtons';

type Props = {
    selectedValue: string;
    changeSelectedValue: (value: string) => void;
    ipConfig: { [x: string]: string }
}


const ChannelFilter = ({ selectedValue, ipConfig, changeSelectedValue }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    // const [checkboxStatus, setCheckboxStatus] = useState({ "Shopify": false, "Amazon Seller Central": false })
    const [checkboxList, setCheckboxList] = useState([]);
    const [checkboxStatusObj, setCheckboxStatusObj] = useState({});
    const [selectValuesArr, setSelectedValuesArr] = useState(selectedValue.split(','));

    useEffect(() => {
        setSelectedValuesArr(selectedValue.split(','))
    }, [selectedValue])

    useEffect(() => {
        const connectedIpsOptions = [];
        if (ipConfig['Shopify'] != undefined && ipConfig["Shopify"]['connectionStatus']) {
            connectedIpsOptions.push("Shopify")
        }
        if (ipConfig['Amazon Seller Central'] != undefined && ipConfig["Amazon Seller Central"]['connectionStatus']) {
            connectedIpsOptions.push("Amazon Seller Central")
        }
        if (ipConfig['Amazon Vendor Central'] != undefined && ipConfig["Amazon Vendor Central"]['connectionStatus']) {
            connectedIpsOptions.push("Amazon Vendor Central")
        }
        // if (ipConfig['Flipkart Seller'] != undefined && ipConfig["Flipkart Seller"]['connectionStatus']) {
        //     connectedIpsOptions.push("Flipkart Seller")
        // }
        // if(selectedValue == "All Channels") {
        const checkboxStatusObj = {};
        const allList = connectedIpsOptions.map((item, index) => {
            const isChecked = selectedValue == "All Channels" || selectedValue.includes(item) ? true : false;
            checkboxStatusObj[item] = isChecked;
            return {
                label: item,
            }
        })
        setCheckboxStatusObj(checkboxStatusObj);
        setCheckboxList(allList);
        // }

    }, [selectedValue, isOpen]);

    // const resetValues = () => {
    //     console.log('running reset values')
    //     const connectedIpsOptions = [];
    //     if (ipConfig['Shopify'] != undefined && ipConfig["Shopify"]['connectionStatus']) {
    //         connectedIpsOptions.push("Shopify")
    //     }
    //     if (ipConfig['Amazon Seller Central'] != undefined && ipConfig["Amazon Seller Central"]['connectionStatus']) {
    //         connectedIpsOptions.push("Amazon Seller Central")
    //     }
    //     const checkboxStatusObj = {};
    //     const allList = connectedIpsOptions.map((item, index) => {
    //         const isChecked = selectedValue == "All Channels" || selectedValue == item ? true : false;
    //         checkboxStatusObj[item] = isChecked;
    //         return {
    //             label: item,
    //         }
    //     })
    //     setCheckboxStatusObj(checkboxStatusObj);
    //     setCheckboxList(allList);
    // }


    // console.log('checkboxStatus', checkboxStatusObj);

    return (
        <>
            <Popover
                positions={["bottom"]}
                onClickOutside={() => {
                    setIsOpen(false);
                }}

                // containerClassName="channelFilterPopover"
                content={({ }) => {
                    return (
                        <div className={styles.filterRootContainer}>
                            <div className={styles.topContainer}>
                                {checkboxList.map((item, index) => {
                                    return <label className={styles.optionContainer}>
                                        <input onChange={(e) => {
                                            setCheckboxStatusObj({ ...checkboxStatusObj, [item.label]: e.target.checked })
                                        }} checked={checkboxStatusObj[item.label]} value={checkboxStatusObj[item.label] ? checkboxStatusObj[item.label] : false} className={styles.checkbox} type='checkbox' />
                                        <div className={styles.labelContainer}>
                                            {ipConfig[item.label] != undefined ? <div className={styles.imgContainer}>
                                                <img src={ipConfig[item.label]['logo']} alt="" />
                                            </div> : null}
                                            <div className={styles.labelText}>
                                                {item.label}
                                            </div>
                                        </div>
                                    </label>
                                })}
                            </div>

                            <div className={styles.bottomContainer}>
                                <MeritoButton size='md' type="tertiary" btnText='Cancel' onClick={() => {
                                    setIsOpen(!isOpen)
                                }} />
                                <MeritoButton size='md' type="primary-1" btnText='Apply' onClick={() => {
                                    const selectedChannel = Object.keys(checkboxStatusObj).filter((item, index) => {
                                        if (checkboxStatusObj[item]) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    })
                                    if (selectedChannel.length == checkboxList.length && checkboxList.length > 1) {
                                        changeSelectedValue("All Channels")
                                    } else {
                                        changeSelectedValue(selectedChannel.toString())
                                    }
                                    setIsOpen(!isOpen);
                                }} />
                            </div>

                        </div>
                    )
                }}
                isOpen={isOpen}
                containerStyle={{ zIndex: "1050", boxShadow: "0px 6px 24px 0px rgba(0, 0, 0, 0.10)" }}
            >
                <div className={styles.selectedChannelContainer} onClick={() => {
                    setIsOpen(!isOpen)
                }}>
                    <div className={styles.valueText}>
                        {checkboxList.length == 1 && selectedValue == "All Channels" ? checkboxList[0]?.label : selectValuesArr.length > 1 ? `${selectValuesArr[0]} + ${selectValuesArr.length-1} other${selectValuesArr.length > 2 ? 's': ''}`: selectedValue}
                    </div>
                    <div className={styles.iconContainer}>
                        <DownIcon />
                    </div>
                </div>
            </Popover>
        </>

    );
}

export default ChannelFilter;